interface ClickableVideoItemProps {
  text: string;
  onClick?: () => void;
}

export const ClickableVideoItem = ({
  text,
  onClick,
}: ClickableVideoItemProps) => {
  return (
    <div
      onClick={onClick}
      className="flex justify-center items-center gap-2 px-3 py-2 rounded-md bg-blue-2948FF text-white leading-3 hover:cursor-pointer"
    >
      <div className="flex justify-center gap-2">
        <i className="h-0 ki-outline ki-abstract-41 text-md -mt-[1.5px]" />
        <div className="text-sm truncate max-w-[200px]">{text}</div>
      </div>
    </div>
  );
};
